/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { InputAdapterService } from '@api/services/input-adapter/input-adapter.service';
import { OutputAdapterService } from '@api/services/output-adapter/output-adapter.service';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@api/services/api/api.service';
import { Injectable } from '@angular/core';
import {
  ApiParams,
  DigitalSignStartDTO,
  DigitalSignVerifyDTO,
  NotificationDTO
} from '@api/models';

@Injectable()
export class ApiCustomService extends ApiService {
  constructor(
    protected http: HttpClient,
    protected outputAdapter: OutputAdapterService,
    protected inputAdapter: InputAdapterService
  ) {
    super(http, outputAdapter, inputAdapter);
  }

  getNotifications(
    params: ApiParams<{ positionId: string }, void>
  ): Observable<NotificationDTO[]> {
    return of([]);
  }

  postPositionWithdraw(
    params: ApiParams<{ positionId: string }, { reasonCode: string }>
  ): Observable<any> {
    const url = `${this.apiUrl}/v1/positions/${params.pathParams.positionId}/WITHDRAW_REQUEST`;

    return this.http
      .post<any>(
        url,
        this.inputAdapter.postPositionWithdraw(params).body,
        this.inputAdapter.postPositionWithdraw(params).options
      )
      .pipe(map(res => this.outputAdapter.postPositionWithdraw(res)));
  }

  postSignStart(
    params: ApiParams<{ positionId: string }, void>
  ): Observable<DigitalSignStartDTO> {
    const url = `${this.apiUrl}/v1/positions/${params.pathParams.positionId}/digital-signature/request-dsp`;

    return this.http
      .get<DigitalSignStartDTO>(
        url,
        this.inputAdapter.postSignStart(params).options
      )
      .pipe(map(res => this.outputAdapter.postSignStart(res)));
  }

  getSignVerify(
    params: ApiParams<{ positionId: string }, void>
  ): Observable<DigitalSignVerifyDTO> {
    const url = `${this.apiUrl}/v1/positions/${params.pathParams.positionId}/digital-signature/request-status-dsp`;

    return this.http
      .get<DigitalSignVerifyDTO>(
        url,
        this.inputAdapter.getSignVerify(params).options
      )
      .pipe(map(res => this.outputAdapter.getSignVerify(res)));
  }

  getSignResume(
    params: ApiParams<{ positionId: string }, void>
  ): Observable<DigitalSignStartDTO> {
    const url = `${this.apiUrl}/v1/positions/${params.pathParams.positionId}/digital-signature/sign`;

    return this.http
      .get<DigitalSignStartDTO>(
        url,
        this.inputAdapter.getSignResume(params).options
      )
      .pipe(map(res => this.outputAdapter.getSignResume(res)));
  }
}
